import React, { useState } from "react";
import { Card, Title } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import AssessmentInstrumentForm from "./AssessmentInstrumentForm";
import AssessmentInstrumentList from "./AssessmentInstrumentList";
import { ManagementLayout, Can } from "@components/shared";
import { PERMISSIONS } from "@util/permissions";

export default function AssessmentInstrumentManagement() {
  const [refresh, setRefresh] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <ManagementLayout
      dataComponent={<AssessmentInstrumentList refresh={refresh} />}
      createComponent={
        <Can permission={PERMISSIONS.ASSESSMENT_INSTRUMENTS_CREATE}>
          <Card>
            <Title order={4}>
              {t("create")} {t("assessment_instrument_singular")}
            </Title>
            <AssessmentInstrumentForm
              onSuccess={(instrument) => {
                setRefresh(!refresh);
                if (instrument?.id) navigate(`/instruments/${instrument.id}`);
              }}
            />
          </Card>
        </Can>
      }
    />
  );
}
